<template>
  <div>
    <div class="pageSatatus">
      <iframe
        :src="iframeSrc"
        frameborder="0"
        ref="iframeRef"
        @load="onIframeLoad"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    assetsDomain() {
      console.log('TT投放助手-process.env.NODE_ENV', process.env);
      console.log('TT投放助手-process.env.NODE_ENV', JSON.stringify(process.env));
      let domainUrl = '';
      if (process.env.VUE_APP_API_ENV === 'development') {
        domainUrl = 'http://cgl.giikin.com:5173';
      } else if (process.env.VUE_APP_API_ENV === 'develop') {
        domainUrl = 'http://cgl.giikin.com:5173';
      } else if (process.env.VUE_APP_API_ENV === 'test') {
        domainUrl = 'https://adstest.giikin.com';
      } else {
        domainUrl = 'https://gk-ads.giikin.com';
      }
      console.log('TT投放助手-iframeSrc', domainUrl);
      return domainUrl;
    },
    iframeSrc() {
      return `${this.assetsDomain}/googleProperty`;
    },
  },
  methods: {
    onIframeLoad() {
      const saToken = localStorage.getItem('saToken');
      const postParams = {
        saToken: saToken,
        type: 'fromTtAssiant',
      };
      this.$refs.iframeRef.contentWindow.postMessage(postParams, this.assetsDomain);
    },
  },
};
</script>

<style lang="scss" scoped>
.pageSatatus {
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: calc(100vh - 90px);
  }
}
</style>
